module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Meldung4.8bfb57d2.jpg";